import { render } from "./App.vue?vue&type=template&id=f1aa2cfc"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=f1aa2cfc&lang=scss"
script.render = render

export default script